/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_project_region": "us-east-1",
  // "aws_cognito_identity_pool_id": "us-east-1:b8855d74-e5c2-486c-9b81-506c0cd45466",
  "aws_cognito_region": "us-east-1",
  // aws_user_pools_id: process.env.REACT_APP_STAGE !== 'dev' ? 'us-east-1_tgzD1gFbF' : 'us-east-1_OW9MAVxvz',
  aws_user_pools_id: 'us-east-1_OW9MAVxvz',
  aws_user_pools_web_client_id: process.env.REACT_APP_STAGE !== 'prod' ? '7hoknn3p5us9o8a63ldh5gbn3r' : '2qbl8uu09c8ai0794rg8sbr66s',
  "oauth": {}
};


export default awsmobile;
